import {Button} from 'antd'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext} from 'react'
import {BsTextParagraph} from 'react-icons/bs'
import {RiErrorWarningLine, RiHashtag, RiLink, RiNewspaperLine,} from 'react-icons/ri'
import {NullAsDefault, renderElse} from 'views/Shared'
import {CodiActions} from './codiHelpers'
import CodiContext from './CodiContext'
import {PiBooks} from "react-icons/pi";
import {VscListTree} from "react-icons/vsc";
import {BiCommentError} from "react-icons/bi";

const CodiShortcuts = ({current}) => {

    const t = useTranslate()
    const {handleAction = NullAsDefault} = useContext(CodiContext)

    return (
        <div
            style={{
                height: 'calc(var(--header-height)',
                top: 'calc(var(--header-visible-height) - 1px)',
            }}
            className="px-3 flex flex-center gap-2 background shadow sticky z-3">
            <div className="flex gap-2 overflow-y-hidden overflow-auto py-2">
                {[
                    {
                        label: 'information',
                        icon: <RiErrorWarningLine size={18}/>,
                        value: CodiActions.SHOW_INFO_MODAL,
                    },
                    {
                        label: 'table of contents',
                        icon: <VscListTree size={18}/>,
                        value: CodiActions.SHOW_INDEXES_MODAL,
                    },
                    {
                        label: 'bros codi',
                        icon: <PiBooks size={18}/>,
                        value: CodiActions.SHOW_BROS_CODI_MODAL,
                    },
                    {
                        label: 'keywords',
                        icon: <RiHashtag size={18}/>,
                        value: CodiActions.SHOW_KEYWORDS_MODAL,
                    },
                    {
                        label: 'related articles',
                        icon: <RiNewspaperLine size={18}/>,
                        value: CodiActions.SHOW_RELATED_ARTICLES_MODAL,
                    },
                    // {
                    //   label: 'related codi',
                    //   icon: <RiFilePaper2Line size={14}/>,
                    //   value: CodiActions.SHOW_RELATED_CODI_MODAL,
                    // },
                    {
                        label: 'notes',
                        icon: <BiCommentError size={18}/>,
                        value: CodiActions.SHOW_NOTES_MODAL,
                    },
                    {
                        label: 'links',
                        icon: <RiLink size={18}/>,
                        value: CodiActions.SHOW_LINKS_MODAL,
                    },
                    {
                        label: 'detail',
                        icon: <BsTextParagraph size={18}/>,
                        value: CodiActions.SHOW_DETAIL_MODAL,
                    },
                ].map(({label, icon, value}, index) => (
                    <Button
                        key={index}
                        icon={icon}
                        onClick={() => {
                            handleAction(value)
                        }}
                        size={35}
                        style={{padding: 8}}
                        className="flex flex-center rounded-md bg-primary-50 text-primary no-border">
                        {renderElse(!!icon, t(label))}
                    </Button>
                ))}
            </div>
        </div>
    )
}

export default CodiShortcuts
